// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"5ee44ec8","95":"fccd78c3","99":"f56d4dbe","219":"9b7cb874","223":"3eae385b","299":"8ea2e73f","457":"5e0fde3e","849":"6bc4b634","997":"70e09d8d"}[chunkId] + ".chunk.js";
};